<div [attr.data-tooltip]="tooltip">
    {{(firstname[0] | cleanString).toUpperCase() + (lastname[0] | cleanString).toUpperCase()}}
</div>